function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "row"
};
var _hoisted_2 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_v_top_navigation = _resolveComponent("v-top-navigation");
  var _component_b_col = _resolveComponent("b-col");
  var _component_b_row = _resolveComponent("b-row");
  var _component_v_ifas_card = _resolveComponent("v-ifas-card");
  var _component_v_layout = _resolveComponent("v-layout");
  return _openBlock(), _createBlock(_component_v_layout, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_b_row, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_b_col, {
            cols: "12",
            class: "mb-4"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_v_top_navigation, {
                url: _ctx.originUrl(),
                text: "Cookies"
              }, null, 8 /* PROPS */, ["url"])];
            }),
            _: 1 /* STABLE */
          })];
        }),
        _: 1 /* STABLE */
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_v_ifas_card, {
        nonCollapsible: true
      }, {
        header: _withCtx(function () {
          return _toConsumableArray(_cache[0] || (_cache[0] = [_createElementVNode("h4", {
            class: "mb-0"
          }, "Cookies a právní prohlášení", -1 /* CACHED */)]));
        }),
        default: _withCtx(function () {
          return [_cache[1] || (_cache[1] = _createElementVNode("p", null, " Tento web používá k poskytování služeb, personalizaci reklam a analýze návštěvnosti soubory cookie. Používáním tohoto webu s tím souhlasíte. ", -1 /* CACHED */)), _cache[2] || (_cache[2] = _createElementVNode("p", {
            class: "mb-0"
          }, [_createElementVNode("a", {
            target: "_blank",
            href: "https://www.creasoft.cz/zasady-cookies-eu-2/"
          }, "Více informací o cookies")], -1 /* CACHED */)), _cache[3] || (_cache[3] = _createElementVNode("p", {
            class: "mb-0"
          }, [_createElementVNode("a", {
            target: "_blank",
            href: "https://www.creasoft.cz/ochrana-osobnich-udaju/"
          }, "Zásady zpracování osobních údajů")], -1 /* CACHED */))];
        }),
        _: 1 /* STABLE */
      })])])];
    }),
    _: 1 /* STABLE */
  });
}